module.exports = __webpack_public_path__ + "static/media/perfectwedding.30463009.png";